export const del = (text: string) => `<del>${text}</del>`
